import { useState, useEffect } from 'react';
import { merchantsService } from '../../../services';
import { Merchant } from '../../../types';

export const useMerchants = () => {
  const [merchants, setMerchants] = useState<Merchant[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchMerchants = async () => {
    try {
      setLoading(true);
      const data = await merchantsService.getMerchants();
      setMerchants(data);
      setError(null);
    } catch (err: any) {
      setError(err.message || 'Ошибка при загрузке мерчантов');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMerchants();
  }, []);

  return {
    merchants,
    loading,
    error,
    refetch: fetchMerchants
  };
}; 